import { render, staticRenderFns } from "./select-brand.vue?vue&type=template&id=8794043c&scoped=true"
import script from "./select-brand.vue?vue&type=script&lang=js"
export * from "./select-brand.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8794043c",
  null
  
)

export default component.exports